const whatsappTriggers = () => {
  const $whatsappWidget = $('.rnk-componente-whatsapp-fixed');
  const $msg = $whatsappWidget.find('.help');
  const $btnClose = $whatsappWidget.find('.close-wp');

  $btnClose.on('click', () => {
    $msg.addClass('d-none');
  });
};

whatsappTriggers();

export {};
